/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useContext, useState, useEffect, useMemo} from 'react'
import {useQuery} from 'react-query'
import {
    createResponseContext,
    initialQueryResponse,
    initialQueryState,
    PaginationState,    
    stringifyRequestQuery,
    WithChildren,
    Response
} from '../../../../../_metronic/helpers'

import { getDLMDOCs } from '../_requests'
import { DLMDOCListItem } from '../_models'
import { useDLMDOCQueryRequest } from './DLMDOCQueryRequestProvider'
import { useAuth } from '../../../auth'


const DLMDOCQueryResponseContext = createResponseContext<DLMDOCListItem>(initialQueryResponse)
const DLMDOCQueryResponseProvider: FC<WithChildren> = ({children}) => {
    const {state} = useDLMDOCQueryRequest()
    const {currentUser} = useAuth();

    const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
    const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state])
    

    useEffect(() => {        
        if (query !== updatedQuery) {
            setQuery(updatedQuery)
        }
    }, [updatedQuery])

    const {
        isFetching,
        refetch,
        data: response,
    } = useQuery(
        ['DLMDOC-LIST'],        
        // @ts-ignore
        () => {               
            if (currentUser && currentUser.role === 'System Admin') {
                // dummy response for 'System Admin' only accounts
                return Promise.resolve().then(() => {
                    return {data : [] , payload : {}};
                })
            } else { 
                return getDLMDOCs();
            }            
        },
        {cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false}
    )

    return (
    <DLMDOCQueryResponseContext.Provider value={{isLoading: isFetching, refetch, response, query}}>
        {children}
    </DLMDOCQueryResponseContext.Provider>
    )
}

const useDLMDOCQueryResponse = () => useContext(DLMDOCQueryResponseContext)

const useDLMDOCQueryResponseData = () => {
    const {response} = useDLMDOCQueryResponse()
    if (!response) {
        return []
    }

    return response?.data || []
}

const useDLMDOCQueryResponsePagination = () => {
    const defaultPaginationState: PaginationState = {
        links: [],
        ...initialQueryState,
    }

  const {response} = useDLMDOCQueryResponse()
    if (!response || !response.payload || !response.payload.pagination) {
        return defaultPaginationState
    }

    return response.payload.pagination
}

const useDLMDOCQueryResponseLoading = (): boolean => {
  const {isLoading} = useDLMDOCQueryResponse()
  return isLoading
}

export {
    DLMDOCQueryResponseProvider,
    useDLMDOCQueryResponse,
    useDLMDOCQueryResponseData,
    useDLMDOCQueryResponsePagination,
    useDLMDOCQueryResponseLoading,
}


export type DLMDOCQueryResponse = Response<Array<DLMDOCListItem>>